import { Money } from '@dreryk/money-common-api';

import { NotificationSize, NotificationStatusIcon, NotificationType } from '@dreryk/react-components';

import { advancePaymentStatusVisitor } from '../shared/advancePaymentStatusVisitor';

type AdvancePaymentStatusIconProps = {
   paidAmount: Money;
   requiredAmount: Money;
};

export const AdvancePaymentStatusIcon = (props: AdvancePaymentStatusIconProps): JSX.Element => {
   return advancePaymentStatusVisitor(props, {
      visitPaid: () => <NotificationStatusIcon size={NotificationSize.NORMAL} type={NotificationType.SUCCESS} />,
      visitUnderpayment: () => <NotificationStatusIcon size={NotificationSize.NORMAL} type={NotificationType.ERROR} />,
      visitOverpayment: () => <NotificationStatusIcon size={NotificationSize.NORMAL} type={NotificationType.WARNING} />,
   });
};
